import { defineAsyncComponent, toRaw } from "vue";
import { CriterionOperator } from "@/generated/graphql";
import type { AuthorizationRuleForGatingInput } from "../use-gating-rule-conversion";
import type {
  CriterionApplyContext,
  GatingCriterionTypeDefinition,
} from "./gating-criterion-type";
import { GatingStrategyType } from "../strategies/gating-strategy";

export const productCriterionType: GatingCriterionTypeDefinition = {
  presetId: "product_purchasers",
  classificationKey: GatingStrategyType.product,
  capabilityKey: "canUseProductsGating",

  labelKey: "channel.gating.builder.presets.productPurchasers.label",
  descriptionKey:
    "channel.gating.builder.presets.productPurchasers.description",
  icon: "material-symbols:shopping-bag-outline",
  columnHeaderKey: "channel.gating.builder.featureRows.requiredProducts",

  hasCriterion(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.product_purchase_criterion;
  },

  isGated(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.product_purchase_criterion;
  },

  applyDefaults(
    rule: AuthorizationRuleForGatingInput,
    _context: CriterionApplyContext,
  ): void {
    rule.product_purchase_criterion = {
      product_ids: [],
      operator: CriterionOperator.And,
    };
  },

  clearCriterion(rule: AuthorizationRuleForGatingInput): void {
    rule.product_purchase_criterion = undefined;
  },

  copyCriterion(
    source: AuthorizationRuleForGatingInput,
    target: AuthorizationRuleForGatingInput,
  ): void {
    target.product_purchase_criterion = source.product_purchase_criterion
      ? structuredClone(toRaw(source.product_purchase_criterion))
      : undefined;
  },

  criterionEquals(
    a: AuthorizationRuleForGatingInput,
    b: AuthorizationRuleForGatingInput,
  ): boolean {
    return (
      JSON.stringify(a.product_purchase_criterion) ===
      JSON.stringify(b.product_purchase_criterion)
    );
  },

  serializeCriterion(rule: AuthorizationRuleForGatingInput): unknown {
    return rule.product_purchase_criterion;
  },

  expandedLayout: "below",

  indeterminatePlaceholder: defineAsyncComponent(
    () => import("../builder/components/product-indeterminate-placeholder.vue"),
  ),

  expandedValueEditor: defineAsyncComponent(
    () => import("../builder/components/product-expanded-editor.vue"),
  ),
};
